export default __webpack_public_path__ + "resources/icons/n320-20c1.png";